import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=6fa99a45&scoped=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=6fa99a45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa99a45",
  null
  
)

export default component.exports